import React from "react";
import { Link } from "react-router-dom";

function Demo({ democontent }) {
  const { title, image, link } = democontent;
  return (
    <Link to={link}>
      <div
        className="demo-box bg-white rounded shadow-dark"
        style={{
          width: "100%",
          height: "300px",
          overflow: "hidden",
          margin: "0 auto",
          display: "inline-block",
          position: "relative",
          cursor: "pointer",
        }}
      >
        <img src={image} alt={title} />
      </div>
      <h4 className="mb-0 mt-4 text-center">{title}</h4>
    </Link>
  );
}

export default Demo;
